export const planes = {
  mensual: {
    titulo: "Suscripcion Mensual",
    precio: "50.000",
    periodo: "Al mes",
    renueva: "mensualmente",
    link_pago:
      "https://www.mercadopago.com.co/subscriptions/checkout/v2?preapproval_plan_id=b4896ffdab504f37ade023e15eded066",
    should_have_external_reference: true,
  },
  semestral: {
    titulo: "Suscripcion Semestral",
    precio: "250.000",
    periodo: "Cada 6 meses",
    renueva: "semestralmente",
    link_pago:
      "https://www.mercadopago.com.co/subscriptions/checkout/v2?preapproval_plan_id=5a6ff9c1af3e49a19febe6d53388aa49",
    should_have_external_reference: true,
  },
  anual: {
    titulo: "Suscripcion Anual",
    precio: "400.000",
    periodo: "cada 12 meses",
    renueva: "anualmente",
    link_pago:
      "https://www.mercadopago.com.co/subscriptions/checkout/v2?preapproval_plan_id=040757067281462e984118243096b1a9",
    should_have_external_reference: true,
  },
};

const planes_especiales = {
  descuento_300: {
    titulo: "Suscripcion especial",
    precio: "300.000",
    periodo: "cada 12 meses",
    renueva: "anualmente",
  },
};

export const all_plans = {
  ...planes,
  ...planes_especiales,
};
